import { TextField } from '@mui/material';
import { Fragment, useState } from 'react';
import { Prism as SyntaxHighlighter } from 'react-syntax-highlighter';
import { useTarefa } from '../../../../../contexts/TarefaContext';
import { BFChange } from '../../../../../types/components';
import { ITarefaBatch } from '../../../../../types/tarefa';
import { BFGridContainer, BFGridOneLine } from '../../../../BFGrid';
import { v4 as uuidv4 } from 'uuid';

const BackupBat = () => {
    const [tarefa, setTarefa] = useTarefa();

    const configuracaoInicial: ITarefaBatch = tarefa.batch ? tarefa.batch : {
        id: uuidv4(),
        pastaDestino: "",
        comando: ""
    }

    const [bacth, setBacth] = useState<ITarefaBatch>({ ...configuracaoInicial });

    function handleComando(event: BFChange): void {
        event.preventDefault();
        mudarEstadoTarefa({ ...bacth, comando: event.target.value });
    }

    function handlePastaDestino(event: BFChange): void {
        event.preventDefault();
        mudarEstadoTarefa({ ...bacth, pastaDestino: event.target.value });
    }

    function mudarEstadoTarefa(novaConfiguracao: ITarefaBatch): void {
        setBacth(novaConfiguracao);
        setTarefa({ ...tarefa, batch: novaConfiguracao });
    }

    return (
        <Fragment>
            <BFGridContainer>
                <BFGridOneLine>
                    <TextField
                        fullWidth
                        sx={{ marginBottom: "16px", marginTop: "16px" }}
                        id="pastaDestino"
                        name="pastaDestino"
                        label="Pasta Destino"
                        variant="outlined"
                        value={bacth.pastaDestino}
                        onChange={handlePastaDestino}
                        required />
                </BFGridOneLine>

                <BFGridOneLine>
                    <TextField
                        fullWidth
                        sx={{ marginBottom: "16px", marginTop: "16px" }}
                        id="comando"
                        name="comando"
                        label="Comando"
                        variant="outlined"
                        minRows={10}
                        multiline
                        onChange={handleComando}
                        value={bacth.comando}
                        required />
                </BFGridOneLine>
            </BFGridContainer>
            <SyntaxHighlighter language="batch">
                {bacth.comando}
            </SyntaxHighlighter>
        </Fragment>
    )
}

export default BackupBat;